import {
  Pressable,
  ScrollView,
  Text,
  useWindowDimensions,
  View,
} from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Image } from 'expo-image'
import { useRouter } from 'expo-router'
import Head from 'expo-router/head'
import { useTranslation } from 'react-i18next'

import { Icon, symbolName } from '../src/components/ui/Icon'

const LOGO_IMAGE = require('../assets/images/onboarding-hero.jpg')

export default function NotFoundScreen() {
  const { t } = useTranslation(['common', 'notFound'])
  const router = useRouter()
  const insets = useSafeAreaInsets()
  const { height } = useWindowDimensions()

  const goToOnboarding = () => {
    router.replace('/')
  }

  const logoSize = height * 0.2
  const titleSize = height * 0.036
  const descriptionSize = height * 0.0227

  return (
    <View className="flex-1 bg-background-primary">
      <Head>
        <title>{t('common:page_title_app')}</title>
      </Head>
      <View
        className="flex-row justify-between items-center px-5 border-b border-border"
        style={{ paddingTop: insets.top + 12, paddingBottom: 12 }}
      >
        <Pressable
          onPress={goToOnboarding}
          className="w-10 h-10 justify-center items-center"
          accessibilityLabel={t('notFound:go_back')}
          accessibilityRole="button"
        >
          <Icon name={symbolName('xmark', 'close')} size={28} color="#38424B" />
        </Pressable>
        <Text className="text-lg font-medium text-ink">
          {t('notFound:page_not_found')}
        </Text>
        <View className="w-10" />
      </View>

      <ScrollView
        className="flex-1"
        contentContainerClassName="flex-grow px-5 pt-5 pb-8"
        contentContainerStyle={{ paddingBottom: 32 }}
        keyboardShouldPersistTaps="handled"
      >
        <View className="items-center mb-8">
          <Image
            source={LOGO_IMAGE}
            style={{ width: logoSize, height: logoSize * 0.6, maxWidth: '80%' }}
            contentFit="contain"
            accessibilityLabel={t('common:logo_accessibility')}
          />
        </View>

        <Text
          className="text-center text-ink mb-4 font-normal"
          style={{ fontSize: titleSize }}
        >
          {t('notFound:page_not_found')}
        </Text>
        <Text
          className="text-center text-ink-secondary mb-8"
          style={{ fontSize: descriptionSize }}
        >
          {t('notFound:page_not_found_description')}.
        </Text>

        <Pressable
          onPress={goToOnboarding}
          className="w-full h-12 rounded-2xl bg-primary justify-center items-center active:opacity-90"
          accessibilityLabel={t('notFound:go_back')}
          accessibilityRole="button"
        >
          <Text className="text-base font-bold text-primary-foreground">
            {t('notFound:go_back')}
          </Text>
        </Pressable>

        <View className="mt-8 items-center">
          <Text className="text-ink-secondary text-sm">www.vocalise.app</Text>
        </View>
      </ScrollView>
    </View>
  )
}
